import React, { useContext, useState } from 'react';
import { useUserContext } from "../../../context/user";
import ApplicationsIcon from '../../../assets/applications.svg'


export const AllOrNewCheckbox = ({ onChange }: { onChange: (value: boolean) => void }) => {
    const { showNewClaims } = useUserContext();
    const [isChecked, setIsChecked] = useState(showNewClaims);

    const toggleCheckbox = (value: boolean) => {
        setIsChecked(value);
        onChange(value)
    };


    return (
        <div
            className={'w-auto h-12 flex items-center gap-2'}
        >
            <button
                onClick={() => toggleCheckbox(false)}
                className={"h-full px-4 rounded-lg flex flex-row items-center justify-center " + (!isChecked ? "bg-melon-yellow " : "bg-white")}>
                <img src={ApplicationsIcon} alt="" className="mr-2" />
                <span>Все заявки</span>
            </button>
            <button
                onClick={() => toggleCheckbox(true)}
                className={"h-full px-4 rounded-lg flex flex-row items-center justify-center " + (isChecked ? "bg-melon-yellow " : "bg-white")}>
                <div className={"!w-2 !h-2 rounded-full mr-2 " + (isChecked ? "bg-white" : "bg-yellow-400")}></div>
                Новые
            </button>
        </div>
    );
};